import AdminLoginPage from "../components/AdminLoginPage";
import AdminSignupPage from "../components/AdminSignupPage";
import AdminHomePage from "../components/AdminHomePage";
import AdminCategoryManagementPage from "../components/AdminCategoryManagementPage";
import AdminConfigurationPage from "../components/AdminConfigurationPage";
import GlobalFunctions from "./GlobalFunctions";
import AdminBusinessManagementPage from "../components/AdminBusinessManagementPage";
import AdminBusinessDetailsPage from "../components/AdminBusinessDetailsPage";
import UndoManager from "./UndoManager";
import AdminDashboardPage2 from "../components/AdminDashboardPage2";

export default class AllPagesUtil {
  public static load(): void {
    GlobalFunctions.AdminBusinessDetailsPage = AdminBusinessDetailsPage;

    GlobalFunctions.AdminBusinessManagementPage = AdminBusinessManagementPage;

    GlobalFunctions.AdminCategoryManagementPage = AdminCategoryManagementPage;

    GlobalFunctions.AdminConfigurationPage = AdminConfigurationPage;

    GlobalFunctions.AdminDashboardPage2 = AdminDashboardPage2;

    GlobalFunctions.AdminHomePage = AdminHomePage;

    GlobalFunctions.AdminLoginPage = AdminLoginPage;

    GlobalFunctions.AdminSignupPage = AdminSignupPage;

    UndoManager.load();
  }
}
